export const name = 'Validation';

export default function Validation($q, $filter, rnHttp, $window) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  this.validate = function (required, property, value, validationLength, customValidation) {
    var deferred = $q.defer();
    var ref = this;

    if (this.isEmpty()) {
      var promise = this.getValidations();
      promise.then(function (data) {
        angular.forEach(data, function (validation, key) {
          ref.setProperty(validation.validationId, validation);
        });
        var result = ref.validateValue(required, property, value, validationLength, customValidation);
        deferred.resolve(result);
      }, function (reason) {
      });
    } else {
      var result = this.validateValue(required, property, value, validationLength, customValidation);
      deferred.resolve(result);
    }
    return deferred.promise;

  };

  this.validateValue = function (required, property, value, validationLength, customValidation) {
    var validationResult = {};
    validationResult.required = this.validateRequired(required, value);

    if (property !== undefined || validationLength !== undefined) {
      validationResult.length = this.validateLength(property, value, validationLength);
    }

    if (property !== undefined || customValidation !== undefined) {
      validationResult.valid = this.validateRegex(property, value, customValidation);
    }

    if (property !== undefined && customValidation === 'integer') {
      validationResult.max = this.validateMax(property, value);
    }

    return validationResult;
  };

  this.validateRegex = function (property, value, customValidation) {
    var valid = true;

    if (customValidation && customValidation === 'date') {
      return this.validateDate(value);

    } else if (customValidation && customValidation === 'currentDate') {
      return this.validateCurrentDate(value);

    } else {

      if (value && value.length > 0) {
        var regex = '';
        if (customValidation) {
          regex = new $window.XRegExp(this.customValidations[customValidation]);
        } else {
          let validator = this.getProperty(property);
          regex = new $window.XRegExp(validator.validation, validator.validationFlags);
        }
        valid = (value && regex.test(value));
      }
      return valid;
    }

  };

  this.validateDate = function (value) {
    var valid = true;
    if (value !== null) {
      value = $filter('date')(value, 'MM/dd/yyyy');
      var regex = new $window.XRegExp(this.customValidations.date);
      valid = (value && regex.test(value));
    }

    return valid;
  };

  this.validateCurrentDate = function (value) {
    var valid = true;
    if (this.validateDate(value)) {
      if (value) {
        value = $filter('date')(value, 'MM/dd/yyyy');
        var q = new Date();
        var month = q.getMonth();
        var day = q.getDate();
        var year = q.getFullYear();
        var today = new Date(year, month, day);
        var valueDate = new Date(value);
        if (valueDate < today) {
          valid = false;
        }
      }

    } else {
      valid = false;
    }

    return valid;


  };


  this.validateRequired = function (required, value) {
    var valid = true;
    if ((value === undefined || value === null || value.length < 1) && required) {
      valid = false;
    }
    return valid;
  };

  this.validateLength = function (property, value, validationLength) {
    var valid = true;
    var length = 0;
    if (validationLength !== undefined) {
      length = validationLength;
    } else {
      length = this.lengths[property];
    }
    if (length === undefined) {
      length = 100;
    }
    if (value && value.length > length) {
      valid = false;
    }
    return valid;

  };

  /****
   * To be consistent with the Rhino design and architecture this rnHttp call should live in a Rhino service. However, these validations
   * are temporary and will soon be removed and replaced with different code. This is why we are not looking to move this
   * into Rhino. - DJL
   */
  this.getValidations = function () {
    var deferred = $q.defer();
    rnHttp.get('portal_service', 'validation', {cache: true})
      .success(function(data) {
        deferred.resolve(data);
        //$log.debug('Successful Context request: ' + JSON.stringify(data));
      })
      .error(function(reason) {
        deferred.reject(reason);
        //$log.debug('Failed Context request');
      });
    return deferred.promise;
  };

  this.getProperty = function (key) {

    return this.props[key];

  };

  this.setProperty = function (key, value) {
    this.props[key] = value;
  };

  this.isEmpty = function () {
    return Object.getOwnPropertyNames(this.props).length === 0;
  };

  this.validateMax = function (property, value) {
    var valid = true;
    var maxValue = 0;
    maxValue = this.maxValues[property];
    if (maxValue !== undefined) {
      if (value && parseInt(value) > maxValue) {
        valid = false;
      }
    }
    return valid;

  };

  this.props = {};
  this.lengths = {
    "Validator.AAA.SubDomain": "100",
    "Validator.SmsPortal.Name": "100",
    "Validator.Email": "100",
    "Validator.SmsInteg.SafeString": "256",
    "Validator.AAA.AddressLine": "100",
    "Validator.AAA.Alphabetic": "1024",
    "Validator.AAA.Numeric": "100",
    "Validator.AAA.PostalCode": "100",
    "Validator.AAA.Notempty": "200",
    "Validator.AAA.SerialNumber": "100"
  };

  this.maxValues = {
    "OrderCopies": "100000"
  };

  this.customValidations = {
    "integer": "^\\d+$",
    "date": "(0[1-9]|1[012])[- \\/.](0[1-9]|[12][0-9]|3[01])[- \/.](19|20)\\d\\d"

  };
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/validation/validation.service.js